import React from "react";
import { useTranslation } from "react-i18next";
import { FORM_NAME } from "src/constant/common";

const ModalViewVehicleTab = ({ simulationData }) => {
  const { t } = useTranslation("gnc-simulator-6dof");

  const vehicleProperties = [
    { key: "vehicle_length", label: t(`new.vehicle.${FORM_NAME.VEHICLE.LENGTH}`) },
    { key: "vehicle_radius", label: t(`new.vehicle.${FORM_NAME.VEHICLE.RADIUS}`) },
    { key: "dry_mass", label: t(`new.vehicle.${FORM_NAME.VEHICLE.DRY_MASS}`) },
    { key: "propellant_mass", label: t(`new.vehicle.${FORM_NAME.VEHICLE.PROPELLANT_MASS}`) },
    { key: "non_propellant_mass", label: t(`new.vehicle.${FORM_NAME.VEHICLE.NON_PROPELLANT_MASS}`) },
    { key: "engine_mass", label: t(`new.vehicle.${FORM_NAME.VEHICLE.ENGINE_MASS}`) },
    { key: "center_of_gravity_total_mass", label: t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_TOTAL_MASS}`), isArray: true },
    { key: "center_of_gravity_dry_mass", label: t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_DRY_MASS}`), isArray: true },
    { key: "center_of_gravity_tank", label: t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_GRAVITY_TANK}`), isArray: true },
    { key: "center_of_pressure", label: t(`new.vehicle.${FORM_NAME.VEHICLE.CENTER_OF_PRESSURE}`), isArray: true },
    {
      key: "inertia_total_mass",
      label: t(`new.vehicle.${FORM_NAME.VEHICLE.MOMENT_OF_INERTIA_TOTAL_MASS}`),
      unit: <>kgm&sup2;</>,
      isArray: true,
    },
    {
      key: "inertia_dry_mass",
      label: t(`new.vehicle.${FORM_NAME.VEHICLE.MOMENT_OF_INERTIA_DRY_MASS}`),
      unit: <>kgm&sup2;</>,
      isArray: true,
    },
    { key: "gimbal_to_thrust_distance", label: t(`new.vehicle.${FORM_NAME.VEHICLE.GIMBAL_TO_THRUST_DISTANCE}`), isArray: true },
  ];
  
  const vehicleObj = simulationData?.input_data?.vehicle;

  return (
    <div className="m-3">
      {vehicleObj &&
        vehicleProperties.map(({ key, label, unit, isArray }) => {
          return (
            <div className="fw-bold mb-3" key={key}>
              <span>{label}</span>
              <span> ({unit || vehicleObj?.[key]?.unit}) = </span>
              <span>{isArray ? `[${vehicleObj?.[key]?.value?.join(", ")}]` : vehicleObj?.[key]?.value}</span>
            </div>
          );
        })}
    </div>
  );
};

export default ModalViewVehicleTab;
